import {
  Col,
  Row,
  Skeleton,
  Avatar,
  Empty,
  Card,
  Space,
  Form,
  Input,
  Button,
  Steps,
  Modal,
  Popover,
  Drawer,
} from "antd";

import axios from "axios";
import PropTypes from "prop-types";
import Layout from "../Layout";
import React, { ReactElement, useCallback, useEffect, useState } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import {
  BarcodeOutlined,
  EditOutlined,
  PhoneOutlined,
  PushpinOutlined,
} from "@ant-design/icons";
import { useParams } from "react-router";
import { authenticateToken } from "../../../utils/auth";
import { responseNotification } from "../../../utils/notify";
import TopHeader from "../Layout/topHeader";
import {
  DmOrderTypeArray,
  MerchantOrderTypeArray,
  OrderTypeArray,
} from "../../../utils";
import OrderProductList from "./products";
import moment from "moment";
import FeedbackDetailsData from "../../Feedback/Details/details";
import NeighborhoodMap from "../../Order/Map/OrderNeighborhood";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faComments,
  faHeadset,
  faGlobe,
} from "@fortawesome/free-solid-svg-icons";
const { TextArea } = Input;
const { Step } = Steps;

const OrderDetails = ({
  selectedOrder,
}: {
  selectedOrder?: string;
}): ReactElement => {
  const route = useParams();
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [form] = Form.useForm();
  const [visible, setVisible] = useState(undefined);
  const [showDrawer, setShowDrawer] = useState(undefined);
  const [showMapDrawer, setShowMapDrawer] = useState(false);
  const [edit, setEdit] = useState(false);
  const [loading, setLoading] = useState(false);

  const [singleOrderInfo, setSingleOrderInfo] = useState({
    loading: false,
    data: null,
  });

  const fetchOrderDetails = useCallback((getOrderId) => {
    if (getOrderId) {
      try {
        setSingleOrderInfo({ loading: true, data: undefined });
        axios
          .get(
            `${process.env.REACT_APP_ORDER_API}/admin/order/details?orderId=${getOrderId}`,
            {
              headers: {
                Authorization: `Bearer ${authenticateToken()}`,
                "Content-Type": "application/json",
              },
            }
          )
          .then((data) => {
            if (data.status === 200) {
              setSingleOrderInfo({
                loading: false,
                data: data?.data?.order,
              });
              setSelectedProducts(data?.data?.order?.products || []);
            } else {
              setSingleOrderInfo({ loading: false, data: null });
              responseNotification(
                data.statusText || "something went wrong",
                "error"
              );
            }
          })
          .catch((err) => {
            setSingleOrderInfo({ loading: false, data: null });
            console.log(err);
          });
      } catch (error) {
        setSingleOrderInfo({ loading: false, data: null });
        console.log(error, "error");
      }
    }
  }, []);

  const editOrder = useCallback(
    (data) => {
      try {
        axios
          .put(
            `${process.env.REACT_APP_ORDER_API}/admin/order`,
            {
              orderId: (route as any)?.orderId || selectedOrder,
              shippingAddress: data?.shippingAddress,
            },
            {
              headers: {
                Authorization: `Bearer ${authenticateToken()}`,
                "Content-Type": "application/json",
              },
            }
          )
          .then((data) => {
            if (data.status === 200) {
              responseNotification(
                "Sipping Address updated successfully!",
                "success"
              );
              setEdit(false);
              fetchOrderDetails((route as any)?.orderId || selectedOrder);
            } else {
              responseNotification(
                data.statusText || "something went wrong",
                "error"
              );
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } catch (error) {
        console.log(error, "error");
      }
    },
    [fetchOrderDetails, route, selectedOrder]
  );

  const editOrderProducts = useCallback(() => {
    try {
      axios
        .put(
          `${process.env.REACT_APP_ORDER_API}/admin/order`,
          {
            orderId: (route as any)?.orderId || selectedOrder,
            products: selectedProducts?.map((product) => ({
              productId: product?.id,
              quantity: product?.quantity || 1,
              variationId:
                product?.variations?.[0]?.variationId ||
                product?.variation?.variationId,
            })),
          },
          {
            headers: {
              Authorization: `Bearer ${authenticateToken()}`,
              "Content-Type": "application/json",
            },
          }
        )
        .then((data) => {
          if (data.status === 200) {
            responseNotification("Product added successfully!", "success");
            fetchOrderDetails((route as any)?.orderId || selectedOrder);
          } else {
            responseNotification(
              data.statusText || "something went wrong",
              "error"
            );
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.log(error, "error");
    }
  }, [fetchOrderDetails, route, selectedOrder, selectedProducts]);

  useEffect(() => {
    fetchOrderDetails((route as any)?.orderId || selectedOrder);
  }, [fetchOrderDetails, route, selectedOrder]);

  const order = singleOrderInfo?.data;

  const onSubmit = async (data) => {
    setLoading(true);

    const readyData = data && {
      orderId: order.id,
      status: "INITIATED",
      // deliveryManId: "deliveryManId",
      products: [
        {
          productId: data.productId,
          quantity: data.quantity * 1,
          variationId: "0",
        },
      ],
    };

    await fetch(`${process.env.REACT_APP_ORDER_API}/admin/order`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${authenticateToken()}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ...readyData,
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        setLoading(false);

        if (res.statusCode === 200) {
          responseNotification("Order Updated Successfully", "success");
          form.resetFields();
        } else if (res.status === 500) {
          responseNotification("Internal server error", "error");
        } else {
          responseNotification(res.message || "something wrong", "warning");
        }
      })
      .catch((err) => {
        setLoading(false);
        responseNotification(`${"Internal server error"} ${err}`, "error");
        console.error("err", err);
      });
  };
  //
  const onClose = () => {
    setShowDrawer(undefined);
    setShowMapDrawer(undefined);
  };

  return (
    <Layout>
      <React.Fragment>
        <div className="product-information-area">
          {singleOrderInfo?.data?.loading ? (
            <>
              <Skeleton avatar active paragraph={{ rows: 20 }} />
            </>
          ) : (
            <>
              <div className="top-heading-products top-heading-content">
                <div className="container-fluid">
                  <TopHeader
                    orderDetails={singleOrderInfo?.data}
                    selectedProducts={selectedProducts}
                    refetch={() =>
                      fetchOrderDetails(
                        singleOrderInfo?.data?.orderId || selectedOrder
                      )
                    }
                  />
                </div>
              </div>
              <div className="order_details_area">
                <Row gutter={10} className="mt-0">
                  <Col
                    span={17}
                    xxl={17}
                    xl={17}
                    lg={17}
                    md={24}
                    sm={24}
                    xs={24}
                  >
                    <Card
                      title={<h4 className="mb-0">Order Details</h4>}
                      className="h-100"
                      size="small"
                      extra={
                        <>
                          {order?.orderedByClientInfo && (
                            <Popover
                              placement="bottomRight"
                              title={
                                <small className="text-center">Placed By</small>
                              }
                              content={
                                <div className="d-flex justify-content-start align-items-center">
                                  {order?.orderedByClientInfo
                                    ?.profilePicture && (
                                    <Avatar
                                      src={
                                        order?.orderedByClientInfo
                                          ?.profilePicture
                                      }
                                      size={38}
                                      className="mr-2"
                                    />
                                  )}
                                  <span>
                                    {order?.orderedByClientInfo?.name}
                                    <br />
                                    <small>
                                      {order?.orderedByClientInfo?.mobileNumber?.split(
                                        "+88"
                                      )}
                                    </small>
                                  </span>
                                </div>
                              }
                            >
                              <Button type="dashed" title="Placed By">
                                <FontAwesomeIcon icon={faHeadset} />
                              </Button>
                            </Popover>
                          )}
                          <Button
                            type="dashed"
                            className="mx-1"
                            onClick={() => setShowDrawer(true)}
                            title="Customer Feedback"
                          >
                            <FontAwesomeIcon icon={faComments} />
                          </Button>
                          <Button
                            type="dashed"
                            className="mx-1"
                            onClick={() => setShowMapDrawer(true)}
                            title="Order Details Neighborhood"
                          >
                            <FontAwesomeIcon icon={faGlobe} />
                          </Button>
                        </>
                      }
                    >
                      <div className="mb-5">
                        <div className="single">
                          <span className="info-name">Base Order ID: </span>
                          <span
                            className="info-desc text-capitalize"
                            style={{ whiteSpace: "nowrap" }}
                          >
                            {order?.baseOrderId}
                          </span>
                        </div>
                        <div className="single">
                          <span className="info-name">Order ID: </span>
                          <span
                            className="info-desc text-capitalize"
                            style={{ whiteSpace: "nowrap" }}
                          >
                            {order?.orderId}
                          </span>
                        </div>
                        <div className="single">
                          <span className="info-name">Order Date: </span>
                          <span
                            className="info-desc text-capitalize"
                            style={{ whiteSpace: "nowrap" }}
                          >
                            {moment(order?.createdAt).format("lll")}
                          </span>
                        </div>
                        <div className="single">
                          <span className="info-name">Payment Method: </span>
                          <span className="info-desc">
                            {order?.paymentMethod.replace("_", " ")}
                          </span>
                        </div>
                        <div className="single">
                          <span className="info-name">Payment Status: </span>
                          <span className="info-desc">
                            {order?.paymentStatus}
                          </span>
                        </div>
                        {order?.total !== order?.totalPaid && (
                          <div className="single">
                            <span className="info-name">Total Paid: </span>
                            <span className="info-desc">
                              &#2547;{parseInt(order?.totalPaid)}
                            </span>
                          </div>
                        )}
                        {order?.total !== order?.totalPaid && (
                          <div className="single">
                            <span className="info-name">Due: </span>
                            <span className="info-desc">
                              &#2547;
                              {order?.total - order?.totalPaid}
                            </span>
                          </div>
                        )}
                        {order?.promoCode && (
                          <div className="single">
                            <span className="info-name">Promo Code: </span>
                            <span className="info-desc">
                              {order?.promoCode}
                            </span>
                          </div>
                        )}
                      </div>
                      <div className="product-information-tab-menu">
                        <Row gutter={20}>
                          <Col span={12}>
                            <h3 className="title">Customer</h3>
                            <div>
                              <div className="single">
                                <span className="info-name">Name :</span>
                                <span className="info-desc text-capitalize">
                                  {order?.customer?.name}
                                </span>
                              </div>

                              <div className="single">
                                <span className="info-name">Phone :</span>
                                <span className="info-desc">
                                  {order?.customer?.mobileNumber.split("+88")}
                                </span>
                              </div>
                            </div>
                          </Col>
                          <Col span={12}>
                            <h3 className="title">Delivery Address</h3>

                            <div className="single">
                              <span className="info-name mr-3">
                                Shipping Address :
                              </span>

                              <EditOutlined
                                className="pointer"
                                onClick={() => setEdit(!edit)}
                                disabled
                              />
                            </div>
                            <div className="single">
                              {edit ? (
                                <div style={{ width: "100%" }}>
                                  <Form
                                    name="control-hooks"
                                    labelCol={{ span: 24 }}
                                    wrapperCol={{ span: 24 }}
                                    className="ant-form ant-form-vertical"
                                    onFinish={editOrder}
                                    // form={form} // like ref
                                    layout="vertical"
                                    autoComplete="off"
                                  >
                                    <Form.Item
                                      hasFeedback
                                      name="shippingAddress"
                                      initialValue={order?.shippingAddress}
                                    >
                                      <TextArea
                                        placeholder="Shipping Address"
                                        rows={4}
                                      />
                                    </Form.Item>
                                    <Button
                                      type="primary"
                                      htmlType="submit"
                                      danger
                                    >
                                      Done
                                    </Button>
                                  </Form>
                                </div>
                              ) : (
                                <span className="info-desc">
                                  {order?.shippingAddress}
                                </span>
                              )}
                            </div>
                          </Col>
                        </Row>

                        <Form
                          name="control-hooks"
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                          className="ant-form ant-form-vertical"
                          onFinish={onSubmit}
                          initialValues={{
                            ...order?.data,
                            // type: type || singleProductInfo?.data?.shop?.type,
                          }}
                          form={form}
                          layout="vertical"
                          autoComplete="off"
                        >
                          {/* //done */}
                          <Row>
                            <Col
                              span={24}
                              className="single-information-product-wrapper mt-4"
                            >
                              <div className="single-information-product-content">
                                <div className="info-body">
                                  <h3 className="title">Shop Information</h3>

                                  <Space align="center">
                                    <div className="pr-4">
                                      <Avatar
                                        size={75}
                                        src={order?.shop?.logo}
                                      />
                                    </div>
                                    <div className="">
                                      <h6 className="font-weight-bold_ text-capitalize mb-0">
                                        {order?.shop?.name}
                                      </h6>
                                      <p className="mb-0">
                                        <small>
                                          <PhoneOutlined className="mr-2" />
                                          {order?.shop?.contactNumber.split(
                                            "+88"
                                          )}
                                        </small>
                                      </p>
                                      <p className="mb-0">
                                        <small>
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="14"
                                            height="14"
                                            viewBox="0 0 18 18"
                                            fill="none"
                                            className="mr-2"
                                          >
                                            <path
                                              d="M15.75 7.5C15.75 12.75 9 17.25 9 17.25C9 17.25 2.25 12.75 2.25 7.5C2.25 5.70979 2.96116 3.9929 4.22703 2.72703C5.4929 1.46116 7.20979 0.75 9 0.75C10.7902 0.75 12.5071 1.46116 13.773 2.72703C15.0388 3.9929 15.75 5.70979 15.75 7.5Z"
                                              stroke="#000"
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                            />
                                            <path
                                              d="M9 9.75C10.2426 9.75 11.25 8.74264 11.25 7.5C11.25 6.25736 10.2426 5.25 9 5.25C7.75736 5.25 6.75 6.25736 6.75 7.5C6.75 8.74264 7.75736 9.75 9 9.75Z"
                                              stroke="#000"
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                            />
                                          </svg>
                                          {order?.shop?.address}{" "}
                                        </small>
                                      </p>
                                    </div>
                                  </Space>
                                </div>
                              </div>
                            </Col>

                            <Col span={24} className="mt-5">
                              <h3 className="title d-flex justify-content-between">
                                Order Items{" "}
                                {/* <Button
                                  danger
                                  type="primary"
                                  onClick={() => setVisible(true)}
                                  disabled={
                                    order?.status === "COMPLETED" ||
                                    order?.status === "DELIVERED" ||
                                    order?.status === "REVIEWED" ||
                                    order?.status === "CANCELLED" ||
                                    order?.status === "ON_DELIVERY"
                                      ? true
                                      : false
                                  }
                                >
                                  <PlusOutlined /> Add More
                                </Button> */}
                              </h3>

                              <div className="product-list-item-area white-bg section-padding-bottom">
                                <div className="product-list-items-inner-content">
                                  <div className="single-product-wrapper">
                                    <div className="single-product-heading major">
                                      <span>Product</span>
                                    </div>
                                    <div className="single-product-heading">
                                      <span>Supplier</span>
                                    </div>
                                    <div className="single-product-heading">
                                      <span>Barcode</span>
                                    </div>
                                    <div className="single-product-heading major">
                                      <span>TP</span>
                                    </div>
                                    <div className="single-product-heading major">
                                      <span>Price</span>
                                    </div>
                                    <div className="single-product-heading major">
                                      <span>Quantity</span>
                                    </div>
                                    <div className="single-product-heading text-right pr-0">
                                      <span className="">Total</span>
                                    </div>
                                  </div>

                                  <div className="product-table_">
                                    <div className="product-table-area">
                                      {selectedProducts?.length ? (
                                        selectedProducts?.map(
                                          (product, index) => (
                                            <React.Fragment key={index}>
                                              <div className="single-product-wrapper px-1">
                                                <div className="single-product major">
                                                  <Avatar
                                                    shape="square"
                                                    size={45}
                                                    alt={product?.name}
                                                    src={product?.productImage}
                                                    className="mr-1"
                                                  />
                                                  <span className="name">
                                                    <small>
                                                      {product?.name}
                                                    </small>
                                                  </span>
                                                </div>

                                                <div className="single-product text-center">
                                                  {product?.supplier?.name && (
                                                    <div
                                                      className="text-center name"
                                                      style={{ width: "100%" }}
                                                    >
                                                      <Popover
                                                        placement="rightBottom"
                                                        title={
                                                          product?.supplier
                                                            ?.name
                                                        }
                                                        content={
                                                          <>
                                                            <PhoneOutlined />{" "}
                                                            <span>
                                                              {product?.supplier?.mobileNumber?.split(
                                                                "+88"
                                                              )}
                                                            </span>
                                                            <br />
                                                            <PushpinOutlined />{" "}
                                                            <span className="name">
                                                              <small>
                                                                {
                                                                  product
                                                                    ?.supplier
                                                                    ?.name
                                                                }
                                                              </small>
                                                            </span>
                                                          </>
                                                        }
                                                        trigger="click"
                                                      >
                                                        <small>
                                                          {
                                                            product?.supplier
                                                              ?.name
                                                          }
                                                        </small>
                                                      </Popover>
                                                    </div>
                                                  )}
                                                </div>
                                                <div className="single-product">
                                                  <span className="name">
                                                    <small className="text-center">
                                                      {
                                                        product?.variation
                                                          ?.variationName
                                                      }
                                                      <br />
                                                      <BarcodeOutlined />
                                                      {product?.variation
                                                        ?.barCode ||
                                                        product?.barCode}
                                                    </small>
                                                  </span>
                                                </div>
                                                <div className="single-product">
                                                  <span className="name">
                                                    &#2547;
                                                    {
                                                      product?.variation?.price
                                                        ?.tp
                                                    }
                                                  </span>
                                                </div>

                                                <div className="single-product major">
                                                  <small className="name">
                                                    &#2547;
                                                    {
                                                      product?.variation?.price
                                                        ?.mrp
                                                    }
                                                    {product?.variation?.price
                                                      ?.discountedPrice !==
                                                    product?.variation?.price
                                                      ?.mrp ? (
                                                      <>
                                                        <span className="text-danger px-1">
                                                          {product?.variation
                                                            ?.productDiscount
                                                            ?.flat ? (
                                                            <>
                                                              {" - "}
                                                              <del>
                                                                &#2547;
                                                                {
                                                                  product
                                                                    ?.variation
                                                                    ?.productDiscount
                                                                    ?.flat
                                                                }
                                                              </del>
                                                            </>
                                                          ) : undefined}
                                                          {product?.variation
                                                            ?.productDiscount
                                                            ?.percentage ? (
                                                            <>
                                                              -
                                                              <del>
                                                                {
                                                                  product
                                                                    ?.variation
                                                                    ?.productDiscount
                                                                    ?.percentage
                                                                }
                                                                %
                                                              </del>
                                                            </>
                                                          ) : undefined}
                                                        </span>
                                                        {product?.variation
                                                          ?.price
                                                          ?.discountedPrice ? (
                                                          <span className=" px-1">
                                                            {"= "}
                                                            &#2547;
                                                            {
                                                              product?.variation
                                                                ?.price
                                                                ?.discountedPrice
                                                            }
                                                          </span>
                                                        ) : (
                                                          <span className="px-1">
                                                            {"= "}
                                                            &#2547;
                                                            {
                                                              product?.variation
                                                                ?.price?.mrp
                                                            }
                                                          </span>
                                                        )}
                                                      </>
                                                    ) : undefined}
                                                  </small>
                                                </div>

                                                {order?.status ===
                                                  "COMPLETED" ||
                                                order?.status === "DELIVERED" ||
                                                order?.status === "CANCELLED" ||
                                                order?.status ===
                                                  "ON_DELIVERY" ? (
                                                  <span className="name major">
                                                    x{product?.quantity}
                                                  </span>
                                                ) : (
                                                  <span className="name major">
                                                    x{product?.quantity}
                                                  </span>
                                                  // <span className="order_input_area">
                                                  //   <div className="input_area">
                                                  //     <Form.Item
                                                  //       hasFeedback
                                                  //       name="productId"
                                                  //       initialValue={
                                                  //         product?.id
                                                  //       }
                                                  //     >
                                                  //       <Input
                                                  //         type="hidden"
                                                  //         style={{
                                                  //           minWidth: 100,
                                                  //         }}
                                                  //       />
                                                  //     </Form.Item>

                                                  //     <Button
                                                  //       onClick={() => {
                                                  //         setSelectedProducts(
                                                  //           (
                                                  //             prevProducts: any
                                                  //           ) => {
                                                  //             const arr =
                                                  //               Array.from(
                                                  //                 prevProducts
                                                  //               );
                                                  //             const newArr =
                                                  //               arr.map(
                                                  //                 (
                                                  //                   item: any
                                                  //                 ) => {
                                                  //                   if (
                                                  //                     item?.id ===
                                                  //                     product?.id
                                                  //                   ) {
                                                  //                     if (
                                                  //                       item &&
                                                  //                       (
                                                  //                         item as any
                                                  //                       )
                                                  //                         .quantity >
                                                  //                         0
                                                  //                     ) {
                                                  //                       return {
                                                  //                         ...item,
                                                  //                         quantity:
                                                  //                           ((
                                                  //                             item as any
                                                  //                           )
                                                  //                             .quantity ||
                                                  //                             0) -
                                                  //                           1,
                                                  //                       };
                                                  //                     } else {
                                                  //                       return item;
                                                  //                     }
                                                  //                   }
                                                  //                   return item;
                                                  //                 }
                                                  //               );

                                                  //             return newArr;
                                                  //           }
                                                  //         );
                                                  //       }}
                                                  //       disabled={
                                                  //         product?.quantity <= 1
                                                  //       }
                                                  //     >
                                                  //       <MinusOutlined />
                                                  //     </Button>

                                                  //     <Input
                                                  //       name="quantity"
                                                  //       type="number"
                                                  //       value={
                                                  //         product?.quantity
                                                  //       }
                                                  //     />

                                                  //     <Button
                                                  //       onClick={() => {
                                                  //         setSelectedProducts(
                                                  //           (
                                                  //             prevProducts: any
                                                  //           ) => {
                                                  //             const arr =
                                                  //               Array.from(
                                                  //                 prevProducts
                                                  //               );
                                                  //             const newArr =
                                                  //               arr.map(
                                                  //                 (
                                                  //                   item: any
                                                  //                 ) => {
                                                  //                   if (
                                                  //                     item?.id ===
                                                  //                     product?.id
                                                  //                   ) {
                                                  //                     if (
                                                  //                       item &&
                                                  //                       (
                                                  //                         item as any
                                                  //                       )
                                                  //                         .quantity >
                                                  //                         0
                                                  //                     ) {
                                                  //                       return {
                                                  //                         ...item,
                                                  //                         quantity:
                                                  //                           ((
                                                  //                             item as any
                                                  //                           )
                                                  //                             .quantity ||
                                                  //                             0) +
                                                  //                           1,
                                                  //                       };
                                                  //                     } else {
                                                  //                       return item;
                                                  //                     }
                                                  //                   }
                                                  //                   return item;
                                                  //                 }
                                                  //               );

                                                  //             return newArr;
                                                  //           }
                                                  //         );
                                                  //       }}
                                                  //       disabled={
                                                  //         product?.quantity >=
                                                  //         product?.variation
                                                  //           ?.stock
                                                  //       }
                                                  //     >
                                                  //       <PlusOutlined />
                                                  //     </Button>
                                                  //     <Button
                                                  //       type="dashed"
                                                  //       danger
                                                  //       className="ml-2"
                                                  //       onClick={async () => {
                                                  //         await setSelectedProducts(
                                                  //           (
                                                  //             prevProducts: any
                                                  //           ) => {
                                                  //             const arr =
                                                  //               Array.from(
                                                  //                 prevProducts
                                                  //               );
                                                  //             const newArr =
                                                  //               arr.filter(
                                                  //                 (item: any) =>
                                                  //                   item?.id !==
                                                  //                   product?.id
                                                  //               );
                                                  //             return newArr;
                                                  //           }
                                                  //         );
                                                  //       }}
                                                  //     >
                                                  //       <CloseOutlined />
                                                  //     </Button>
                                                  //   </div>
                                                  // </span>
                                                )}

                                                <div className="single-product pr-0 justify-content-end">
                                                  {product?.variation?.price
                                                    ?.discountedPrice ? (
                                                    <span className="name">
                                                      {product?.variation?.price
                                                        ?.mrp *
                                                        product?.quantity}
                                                      {""}&#2547;
                                                    </span>
                                                  ) : (
                                                    <span className="name">
                                                      {product?.variation?.price
                                                        ?.mrp *
                                                        product?.quantity}{" "}
                                                      &#2547;
                                                    </span>
                                                  )}
                                                </div>
                                              </div>
                                            </React.Fragment>
                                          )
                                        )
                                      ) : (
                                        <Empty />
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Col>
                          </Row>

                          <Row justify="end" align="top">
                            <Col span={9} className="mb-5">
                              <div className="single px-2">
                                <span className="info-name">Sub Total:</span>
                                <span className="info-desc text-right">
                                  &#2547;{order?.subTotal}
                                  {/* {selectedProducts?.reduce((a, b) => {
                                    return (
                                      a +
                                      b?.quantity *
                                        (b?.variation?.price?.discountedPrice ||
                                          b?.variations?.[0]?.price?.discountedPrice)
                                    );
                                  }, 0)} */}
                                </span>
                              </div>
                              <div className="single px-2">
                                <span className="info-name text-right">
                                  Vat :
                                </span>
                                <span className="info-desc text-right">
                                  &#2547;{order?.vat}
                                </span>
                              </div>
                              <div className="single px-2">
                                <span className="info-name">
                                  Delivery Charge:
                                </span>
                                <span className="info-desc text-right">
                                  &#2547;{order?.deliveryCharge}
                                </span>
                              </div>
                              <div className="single px-2">
                                <span className="info-name">Discount:</span>
                                <span className="info-desc text-right">
                                  &#2547;
                                  {/* {selectedProducts?.reduce((a, b) => {
                                    return (
                                      a +
                                      b?.quantity *
                                        (b?.variation?.price?.mrp -
                                          (b?.variations?.[0]?.price
                                            ?.discountedPrice ||
                                            b?.variation?.price
                                              ?.discountedPrice))
                                    );
                                  }, 0) + order?.discount} */}
                                  {parseInt(order?.discount) -
                                    parseInt(order?.promoDiscount)}
                                </span>
                              </div>
                              <div className="single px-2">
                                <span className="info-name">
                                  Promo ({order?.promo?.promoCode}):
                                </span>
                                <span className="info-desc text-right">
                                  &#2547;
                                  {parseInt(order?.promoDiscount)}
                                </span>
                              </div>
                              <div className="single px-2">
                                <span className="info-name">Total Paid</span>
                                <span className="info-desc text-right">
                                  &#2547;
                                  {parseInt(order?.totalPaid)}
                                </span>
                              </div>
                              <div className="single px-2">
                                <span className="info-name">Total:</span>
                                <span className="info-desc text-right">
                                  &#2547;
                                  {parseInt(order?.total)}
                                  {/* {selectedProducts?.reduce((a, b) => {
                                    return (
                                      a +
                                      b?.quantity *
                                        (b?.variation?.price?.discountedPrice ||
                                          b?.variations?.[0]?.price?.mrp)
                                    );
                                  }, 0) +
                                    order?.deliveryCharge +
                                    order?.vat -
                                    order?.promoDiscount} */}
                                </span>
                              </div>
                              {/* <Button
                                type="primary"
                                danger
                                block
                                onClick={() => {
                                  editOrderProducts();
                                }}
                                disabled={
                                  selectedProducts?.reduce((a, b) => {
                                    return (
                                      a +
                                      b?.quantity *
                                        (b?.variation?.price?.discountedPrice ||
                                          b?.variations?.[0]?.price?.mrp)
                                    );
                                  }, 0) +
                                    order?.deliveryCharge +
                                    order?.vat ===
                                    order?.total ||
                                  order?.status === "COMPLETED" ||
                                  order?.status === "DELIVERED" ||
                                  order?.status === "CANCELLED"
                                    ? true
                                    : false
                                }
                              >
                                Update Order
                              </Button> */}
                            </Col>
                          </Row>

                          {/* <Row gutter={25}>
                          <Col span={24}>
                            <h3 className="title">Notes</h3>
                            <div>
                              <Form.Item
                                hasFeedback
                                // label="Notes"
                                // rules={[
                                //   {
                                //     required: true,
                                //     message: "Notes is Required!",
                                //   },
                                // ]}
                                name="notes"
                              >
                                <TextArea
                                  id="notes"
                                  placeholder="Write your note..."
                                  rows={6}
                                />
                              </Form.Item>

                              <Form.Item
                                style={{
                                  width: "100%",
                                  flex: "1 1 100%",
                                  marginBottom: 5,
                                }}
                              >
                                <Button
                                  disabled={loading}
                                  loading={
                                    (loading ? "loading" : undefined) as any
                                  }
                                  type="primary"
                                  htmlType="submit"
                                  className="add-submit-btn text-center px-5"
                                >
                                  Submit
                                </Button>
                              </Form.Item>
                            </div>
                          </Col>
                        </Row> */}
                        </Form>
                      </div>
                    </Card>
                  </Col>
                  <Col span={7} xxl={7} xl={7} lg={7} md={24} sm={24} xs={24}>
                    <Card
                      className="product-information-show-tab-wrapper h-100"
                      size="small"
                    >
                      <div className="">
                        <Steps
                          current={Object.values(OrderTypeArray).indexOf(
                            order?.status
                          )}
                          direction="vertical"
                          percent={80}
                          style={{ width: "100%", overflowX: "scroll" }}
                          size="small"
                        >
                          {Object.values(OrderTypeArray)?.map((type, i) => (
                            <Step
                              style={{ minWidth: 300 }}
                              key={i}
                              title={type?.split("_").join(" ")}
                              subTitle={
                                order?.statusLogs?.find(
                                  (log) => log?.value === OrderTypeArray[i]
                                )
                                  ? moment(
                                      order?.statusLogs?.find(
                                        (log) =>
                                          log?.value === OrderTypeArray[i]
                                      )?.datetime
                                    ).format("lll")
                                  : undefined
                              }
                              description={
                                <>
                                  {order?.statusLogs?.find(
                                    (log) => log?.value === OrderTypeArray[i]
                                  ) ? (
                                    <>
                                      <i className="mb-0">
                                        {
                                          order?.statusLogs?.find(
                                            (log) =>
                                              log?.value === OrderTypeArray[i]
                                          )?.createdBy?.name
                                        }{" "}
                                      </i>
                                      <br />
                                    </>
                                  ) : undefined}

                                  <small>
                                    {order?.statusLogs?.[i]
                                      ? order?.statusLogs?.[i]?.note
                                      : undefined}
                                  </small>
                                </>
                              }
                            />
                          ))}
                        </Steps>
                      </div>

                      <div className="inner-content mt-5">
                        {order?.deliveryMan?.name ? (
                          <div className="single-information-product-wrapper">
                            <div className="single-information-product-content">
                              <div className="info-body">
                                <h3 className="title">
                                  Assigned Delivery Hero
                                </h3>
                                <div className="inner-body">
                                  <div className="single">
                                    <span className="info-name">
                                      Delivery Hero
                                    </span>
                                    <span className="info-desc">
                                      {order?.deliveryMan?.name}
                                    </span>
                                  </div>

                                  <div className="single">
                                    <span className="info-name">
                                      Mobile Number
                                    </span>
                                    <span className="info-desc">
                                      {order?.deliveryMan?.mobileNumber?.split(
                                        "+88"
                                      )}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : undefined}
                      </div>
                    </Card>
                  </Col>
                </Row>

                <Row gutter={10} className="mt-2">
                  <Col span={8}>
                    <Card size="small">
                      <div className="">
                        <h4 className="title">Status Logs</h4>
                        <Steps
                          responsive={true}
                          current={order?.statusLogs?.length - 1}
                          direction="vertical"
                          percent={70}
                          size="small"
                        >
                          {order?.statusLogs?.length
                            ? order?.statusLogs?.map((log, index) => (
                                <Step
                                  key={index}
                                  title={log?.value?.split("_").join(" ")}
                                  subTitle={moment(log?.datetime).format("lll")}
                                  description={
                                    <>
                                      {order?.statusLogs?.[index]
                                        ? order?.statusLogs?.[index]?.createdBy
                                            ?.name
                                        : undefined}
                                      (
                                      <small>
                                        {order?.statusLogs?.[index]
                                          ? order?.statusLogs?.[index]?.note
                                          : undefined}
                                      </small>
                                      )
                                    </>
                                  }
                                />
                              ))
                            : undefined}
                        </Steps>
                      </div>
                    </Card>
                  </Col>

                  <Col span={8}>
                    <Card size="small">
                      <div className="">
                        <h4 className="title">Status of Merchant</h4>
                        <Steps
                          current={Object.values(
                            MerchantOrderTypeArray
                          ).indexOf(order?.statusOfMerchant)}
                          direction="vertical"
                          percent={80}
                          style={{ width: "100%", overflowX: "scroll" }}
                          size="small"
                        >
                          {Object.values(MerchantOrderTypeArray)?.map(
                            (type, i) => (
                              <Step
                                style={{ minWidth: 300 }}
                                key={i}
                                title={type?.split("_").join(" ")}
                                description={
                                  order?.statusLogs?.find(
                                    (log) =>
                                      log?.value === MerchantOrderTypeArray[i]
                                  )
                                    ? moment(
                                        order?.statusLogs?.find(
                                          (log) =>
                                            log?.value ===
                                            MerchantOrderTypeArray[i]
                                        )?.datetime
                                      ).format("lll")
                                    : undefined
                                }
                              />
                            )
                          )}
                        </Steps>
                      </div>
                    </Card>
                  </Col>

                  <Col span={8}>
                    <Card size="small">
                      <div className="">
                        <h4 className="title">Status of Delivery Man</h4>
                        <Steps
                          current={Object.values(DmOrderTypeArray).indexOf(
                            order?.statusOfDeliveryMan
                          )}
                          direction="vertical"
                          percent={80}
                          style={{ width: "100%", overflowX: "scroll" }}
                          size="small"
                        >
                          {Object.values(DmOrderTypeArray)?.map((type, i) => (
                            <Step
                              style={{ minWidth: 300 }}
                              key={i}
                              title={type?.split("_").join(" ")}
                              description={
                                order?.statusLogs?.find(
                                  (log) => log?.value === DmOrderTypeArray[i]
                                )
                                  ? moment(
                                      order?.statusLogs?.find(
                                        (log) =>
                                          log?.value === DmOrderTypeArray[i]
                                      )?.datetime
                                    ).format("lll")
                                  : undefined
                              }
                            />
                          ))}
                        </Steps>
                      </div>
                    </Card>
                  </Col>
                </Row>
              </div>
            </>
          )}

          <Modal
            title={`Add More Product in Order for  - ${
              singleOrderInfo?.data?.customer?.name ||
              singleOrderInfo?.data?.customer?.mobileNumber?.split("+88")
            }`}
            centered
            visible={visible}
            onOk={() => {
              setVisible(undefined);
              editOrderProducts();
            }}
            okText="Re-Place Order"
            destroyOnClose
            onCancel={() => {
              setVisible(undefined);
              fetchOrderDetails((route as any)?.orderId || selectedOrder);
            }}
            width={"80%"}
            className="orderProductModal"
          >
            <OrderProductList
              orderId={(route as any)?.orderId || selectedOrder}
              orderType={singleOrderInfo?.data?.type}
              hubId={singleOrderInfo?.data?.hub?.id}
              selectedProducts={selectedProducts}
              setSelectedProducts={async (products) => {
                setSelectedProducts(products);
              }}
            />
          </Modal>

          <Drawer
            title="Customer Feedback"
            placement="right"
            closable={false}
            onClose={onClose}
            visible={showDrawer}
            width={600}
            getContainer={false}
            style={{ position: "absolute" }}
          >
            <FeedbackDetailsData
              inOrder={true}
              orderId={singleOrderInfo?.data?.baseOrderId}
            />
          </Drawer>

          <Drawer
            title="Show in Map"
            placement="right"
            visible={showMapDrawer}
            onClose={onClose}
            width={600}
            getContainer={false}
          >
            <NeighborhoodMap orderData={singleOrderInfo?.data} />
          </Drawer>
        </div>
      </React.Fragment>
    </Layout>
  );
};
OrderDetails.propTypes = {
  match: PropTypes.object,
  params: PropTypes.object,
};
export default OrderDetails;
